<template>
  <div class="container">
    <div id="login">
      <img src="/static/img/logo_sima_100_full.png" class="center-block logo-login">

    <div class="text-center col-sm-12">
      <div v-if="info" class="text-error"><p class="vertical-5p lead">{{info}}</p></div>
      <!-- login form -->
      <form @submit.prevent="checkCreds">

        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
          <input autocapitalize="off" class="form-control" name="username" placeholder="Usuario" type="text" v-model="form.identifier" @blur="minimizar(form.identifier)">
        </div>

        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-lock"></i></span>
          <input class="form-control" name="password" placeholder="Password" type="password" v-model="form.password">
        </div>
        <button type="submit" class="btn btn-danger btn-lg" :disabled="!activar">
            Entrar 
            <div v-if="loading" class="loading"></div>
        </button>
      </form>

        <!-- errors -->
        <div v-if=response class="text-error"><p class="vertical-5p lead">{{response}}</p></div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../api'
import localStorage from '../core/local-storage'
import {lowerCase} from '../filters/string.js'
export default {
  name: 'Login',
  filters: {
    lowerCase
  },
  data (router) {
    return {
      activar: true,
      info: '',
      section: 'Login',
      loading: false,
      form: {
        identifier: null,
        password: null
      },
      response: ''
    }
  },
  mounted () {
    this.$store.commit('CLEAR_API_DATA', '*')
  },
  methods: {
    checkCreds () {
      let vm = this
      if (!vm.loading) {
        vm.toggleLoading()
        this.form.identifier = this.$options.filters.lowerCase(this.form.identifier)
        api.login(this.form)
          .then(data => {
            vm.info = 'Cargando roles, un momento por favor...'
            localStorage.setToken(data.jwt)
            api.getRoles().then(() => {
              vm.info = ''
              if (!vm.$store.state.apiData.roles[data.user.role._id]) {
                vm.response = 'No esta autorizado para ingresar.'
                localStorage.removeToken()
              } else {
                if (data.user.blocked) {
                  vm.response = 'No esta autorizado para ingresar.'
                  localStorage.removeToken()
                } else {
                  let userData = data.user
                  // userData.proyectos = ['5b3e50f91f3898503bc90ef0', '5b3e52bff46de976b5c46205', '5b451d9236c61a12139ecc66']
                  // userData.proyectos_ids = _.map(userData.proyectos, 'id')
                  localStorage.setUser(userData)
                  vm.$store.commit('SET_USER', userData)
                  vm.$router.push({name: 'dashboard'})
                }
              }

              vm.toggleLoading()
            }, error => {
              localStorage.removeToken()
              vm.info = ''
              vm.response = error.message
              vm.toggleLoading()
            })
          })
          .catch(() => {
            vm.response = 'Usuario/Password incorrectos. Por favor volve a intentarlo.'
            localStorage.removeToken()
            vm.toggleLoading()
          })
      }
    },
    toggleLoading () {
      this.loading = !this.loading
      this.$store.commit('TOGGLE_LOADING')
    },
    resetResponse () {
      this.response = ''
    },
    minimizar (input) {
      this.form.identifier = this.$options.filters.lowerCase(input)
    }
  }
}
</script>

<style>
#login {
    max-width: 500px;
    margin-left: auto;
    margin-right: auto;
}
.text-error{
  text-align: center;
  color: #d9534f;
  font-size: 10px;
  margin-top: 10px;
}
html,
body,
.container-table {
  height: 100%;
  background-color: #282b30 !important;
}
.container-table {
  display: table;
  color: white;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.vertical-5p {
  padding-top: 5%;
}
.logo-login {
  padding: 3em;
  max-width: 460px;
}

#login .input-group {
  padding-bottom: 2em;
  height: 4em;
  width: 100%;
}

#login .input-group span.input-group-addon {
  width: 2em;
  height: 4em;
}

@media (max-width: 1241px) {
  #login .input-group input {
    height: 4em;
  }
}
@media (min-width: 1242px) {

  #login .input-group input {
    height: 6em;
  }
}

.input-group-addon i {
  height: 15px;
  width: 15px;
}

.loading {
    border: 2px solid #f3f3f3;
    border-top: 2px solid #3498db;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    animation: spin 2s linear infinite;
    float: right;
    margin-left: 9px;
    margin-top: 4px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue